var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import dropin from "braintree-web-drop-in";
import { getPaymentMethodToken, postPaymentMethod } from "module/main/store/auth/api";
import LoadingSpinner from "module/common/components/LoadingSpinner";
import LoadingButton from "module/common/components/LoadingButton";
import { formatErrorMessage } from "module/common/utils";
import { addSuccessToast } from "module/main/store/toast/reducer";
import { useAppDispatch } from "module/main/store/hooks";
var BillingInfo = function (_a) {
    var onSubmitCallback = _a.onSubmitCallback, _b = _a.submitButtonText, submitButtonText = _b === void 0 ? "Purchase" : _b;
    var _c = useState(null), dropinInstance = _c[0], setDropinInstance = _c[1];
    var _d = useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(null), error = _f[0], setError = _f[1];
    var dispatch = useAppDispatch();
    useEffect(function () {
        getPaymentMethodToken()
            .then(function (_a) {
            var data = _a.data;
            var token = data.token;
            dropin
                .create({
                authorization: token,
                container: "#dropin-container",
            })
                .then(function (dropinInstance) { return setDropinInstance(dropinInstance); });
        })
            .finally(function () { return setIsLoading(false); });
    }, []);
    var onSubmitPayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nonce, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, dropinInstance.requestPaymentMethod()];
                case 2:
                    nonce = (_a.sent()).nonce;
                    return [4 /*yield*/, postPaymentMethod({ paymentMethodNonce: nonce })];
                case 3:
                    _a.sent();
                    dispatch(addSuccessToast("Payment method modified"));
                    if (!onSubmitCallback) return [3 /*break*/, 5];
                    return [4 /*yield*/, onSubmitCallback()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_1 = _a.sent();
                    setError(formatErrorMessage(error_1));
                    dropinInstance === null || dropinInstance === void 0 ? void 0 : dropinInstance.clearSelectedPaymentMethod();
                    return [3 /*break*/, 8];
                case 7:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    if (isLoading)
        return (_jsx("div", { className: "pt-10", children: _jsx(LoadingSpinner, { color: "primary", className: "mx-auto w-11 h-11" }) }));
    return (_jsxs("div", { className: "flex flex-col", children: [_jsx("div", { id: "dropin-container" }), error ? (_jsxs("div", { className: "bg-danger/50 p-2", children: ["There was an error while processing: ", error] })) : null, _jsx(LoadingButton, { className: "btn-primary", onClick: onSubmitPayment, isLoading: isSubmitting, children: submitButtonText })] }));
};
export default BillingInfo;
